export default "__VITE_ASSET__CMDkbCRz__"